<template>
  <div class="cards-layout">
    <div
      v-if="hasHeader"
      class="cards-layout__header"
    >
      <BasicText size="h5">
        {{ headerText ?? cardsType }}
      </BasicText>
      <BasicLink
        v-if="!isMobile"
        label="Tout voir"
        :disabled="isDisabled"
        wrap-link
        @click="onRedirection"
      />
    </div>
    <div
      v-if="hasCards"
      class="cards-layout__content"
    >
      <BasicCard
        v-for="(card, index) in cards?.slice(0, 6)"
        :key="index"
        v-bind="card"
        @click="() => onCardClick(card)"
      />
    </div>
    <div
      v-else
      class="cards-layout__empty"
    >
      <BasicIcon name="empty-cards-layout" />
      <BasicText v-if="cardsType !== 'Rattachements'">{{ emptyLabel }}</BasicText>
      <div
        v-else
        class="cards-layout__empty-box"
      >
        <BasicText color="white">{{ emptyLabel }}</BasicText>
        <BasicButton
          @click="labelMapping[cardsType]?.emptyCardRedirection"
          label="Configurer mon rattachement"
          icon-name="setting"
        />
      </div>
    </div>
    <div v-if="hasHeader && isMobile">
      <BasicButton
        @click="onRedirection"
        label="Tout voir"
        width="full"
        type="secondary"
        class="cards-layout__btn-redirection"
        :disabled="isDisabled"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, inject } from 'vue'
  import { type CardsLayoutProps, labelMapping } from './CardsLayout.types'
  import { DEVICE_BREAKPOINT } from '@/plugin/device-breakpoint'

  const props = withDefaults(defineProps<CardsLayoutProps>(), {
    selectionnable: false,
    hasHeader: true,
  })

  const { isMobile } = inject(DEVICE_BREAKPOINT)!

  defineEmits(['card-click'])

  const hasCards = computed(() => Boolean(props.cards?.length))
  const isDisabled = computed(() => !hasCards.value)

  const emptyLabel = computed(() => labelMapping[props.cardsType]?.emptyCardLibelle)

  const onRedirection = () => {
    if (!isDisabled.value) props.redirection?.()
  }

  const onCardClick = (card: any) => {
    if (!isDisabled.value) card.onCardClick?.()
  }
</script>

<style scoped lang="less">
  @import './CardsLayout.less';
</style>
